import Grid from '@mui/material/Grid';
import PageProtected from '../../../components/Page/PageProtected';
import SectionHistory from './SectionHistory';


export default function FamilyWelcome() {
   
return (
<>
<PageProtected

        headline="Family Diseases - " 
        specify="History"
        main={<>
                   <Grid container>  
                        <Grid item  xs={12} sx={{mt:{xs:'0em', }, mb:'0em'}}> <SectionHistory /> </Grid>
                  </Grid> 
</>}
/>
 
</>
)}